import { isSSR } from '@/utils/helper';

import initGtagEvents from './gtag';

const initializers: Array<() => void> = [
    initGtagEvents,
];

// SetupHooks.tsx calls this from a mount effect, which React StrictMode (dev
// only) invokes twice — guard HERE so every plugin in `initializers` is
// covered, present and future, instead of each one needing its own flag.
let pluginsInitialized = false;

export const initPlugins = () => {
    if (isSSR || pluginsInitialized) {
        return;
    }
    pluginsInitialized = true;

    for (const init of initializers) {
        init();
    }
};

export * from './core';
